<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="this.page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="所属分区" slot="areaName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.areaName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="门店标签" slot="tagList" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.tagList && row.tagList.length">
            <el-tag size="mini" v-for="item in row.tagList" :key="item.id">{{item.tagName}}</el-tag>
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="门店编码" slot="storeCode" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.storeCode || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="店长" slot="storeMana" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.storeManager" style="color:#0981FF;">{{
            row.storeManager
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" slot="storeMana" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.storeManagerPhone" style="color:#0981FF;">{{
            row.storeManagerPhone
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>

      <el-table-column label="店员数量" slot="operationImg" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.staffCount == 0" style="color:#0981FF;">{{
            row.staffCount
          }}</span>
          <span v-else style="color:#0981FF;border-bottom:1px solid #0981FF;cursor:pointer" @click="staffDia(row)">{{
            row.staffCount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="门店地址" slot="storeAddress" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.storeAddress">{{ row.storeAddress }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="启用/禁用" slot="operationSex" align="center">
        <template slot-scope="{ row }">
          <el-switch inactive-color="#bebebe" @change="handleSwitch(row, 'switch')" v-model="row.isEnable"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="报价设置" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row, 'price')">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="isOpenBuyNiceMachine" label="门店靓机自收" slot="operationSex" align="center">
        <template slot-scope="{ row }">
          <el-switch inactive-color="#bebebe" class="switchStyle" inactive-text="关" active-text="开" @change="SwitchRenew(row, 'switch')" v-model="row.isOpenSelfBuyNiceMachine"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row, 'edit')">编辑</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 二维码弹窗 -->

    <el-dialog title="添加报价设置" :visible.sync="DialogCode" :close-on-click-modal="false" width="500px"
      @closed="DialogCode = false">
      <div class="qustion-top widQus" style="margin-top:0">
        <div><img src="@/assets/images/imgAll/ico_ts_red@2x.png" alt /></div>
        <div>扫码小程序进入报价设置页面，添加/修改报价设置</div>
      </div>
      <div class="img_code">
        <img src="@/assets/images/imgAll/ico_ts_red@2x.png" alt />
      </div>
      <div style="float:right;margin-bottom:10px">
        <el-button @click="DialogCode = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 报价设置弹窗 -->
    <el-dialog title="查看报价设置" :visible.sync="dialogQuotatVisible" :close-on-click-modal="false" width="900px"
      @closed="dialogQuotatVisible = false">
      <div class="qustion-top widQus" style="margin-top:0">
        <div><img src="@/assets/images/ico_ts_red.png" alt /></div>
        <div>
          报价设置仅限于对外显示，避免顾客看到真实价格，员工提成以原价计算
        </div>
      </div>
      <div class="widQus" v-if="pattern == '00'">
        <el-button type="primary" size="mini" @click="editConfig()" icon="el-icon-plus">添加比例</el-button>
      </div>
      <div v-if="quoteList.length > 0">
        <GlobalTable class="mt-20" style='padding-bottom:20px;' ref="GlobalTable" :columns="regionColumns"
          :data="quoteList" :maxHeight="500" :isPagination="false">
          <el-table-column label="最高门店显示价区间" slot="rank" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.startQuote }}≤区间＜{{ row.endQuote }}</span>
            </template>
          </el-table-column>
          <el-table-column label="压价隐藏比例" slot="markUpLimit" align="center">
            <template slot-scope="{ row }">
              <span style="color:#0981FF">{{ row.hideQuoteRatio }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="显示比例（自动计算）" slot="hideQuoteRatio" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.quoteRatio }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="自动压价上限" slot="hideQuoteLimit" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.hideQuoteLimit || row.hideQuoteLimit === 0 ? row.hideQuoteLimit : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="pattern == '00'" label="操作" slot="operation" align="center">
            <template slot-scope="{ row }">
              <el-button type="primary" size="mini" @click="editConfig(row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="deletConfig(row)">删除</el-button>
            </template>
          </el-table-column>
        </GlobalTable>
        <!-- 门店店长设置('01')情况 -->
        <div v-if="pattern == '00'"
          style="display: flex;align-items: center;padding: 20px 10px 30px 10px;" :style="(configAlldata.quoteConfigLastName ||configAlldata.quoteConfigLastTime )?'justify-content: space-between;':'justify-content: flex-end;'">
          <div style="margin-bottom: 20px;" v-if="configAlldata.quoteConfigLastName">
            <span>
              最近修改人：{{ configAlldata.quoteConfigLastName }}{{ configAlldata.quoteConfigLastName ? ' - ' : '' }}{{
                configAlldata.quoteConfigLastAcc
              }}</span>
            <span>({{ configAlldata.quoteConfigLastChannel === '00' ? '小程序' : '门店后台' }})</span>
            <div v-if="configAlldata.quoteConfigLastTime">
              <span style="margin-right: 40px;">
                最近修改时间：{{ configAlldata.quoteConfigLastTime }}</span>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click.native="dialogQuotatVisible = false">取消</el-button>
            <el-button type="primary" @click.native="submitAddPrice()">确定</el-button>
          </span>
        </div>
      </div>
      <div class="none-Data" v-else>
        暂无数据
      </div>
    </el-dialog>
    <!-- 添加/编辑报价设置 -->
    <el-dialog title="编辑加价规则" :visible.sync="editPriceShow" :close-on-click-modal="false" width="500px"
      @closed="editPriceClosed">
      <el-form :model="editPriceForm" :rules="editPricerules" ref="editPriceRulesForm" label-width="83px">
        <el-form-item label="最高门店显示价区间:" label-width="145px">
          <el-col :span="11">
            <el-form-item>
              <el-input size="small" placeholder="最低显示价" v-model.trim="editPriceForm.startQuote" @input="hideQuoteStartQuoteChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center" :span="2">~</el-col>
          <el-col :span="11">
            <el-form-item>
              <el-input size="small" maxlength="5" placeholder="最高显示价" v-model.trim="editPriceForm.endQuote" @input="hideQuoteEndQuoteChange"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="压价隐藏比例:" prop="hideQuoteRatio" label-width="110px">
          <el-input size="small" min="0" max="100" placeholder="输入压价隐藏比例" v-model.trim="editPriceForm.hideQuoteRatio"
            @input="limitInput($event, 'hideQuoteRatio')" @blur="inputBlur('hideQuoteRatio')">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="压价上限:" prop="hideQuoteLimit">
          <el-input size="small" placeholder="输入压价上限" maxlength="5" v-model.trim="editPriceForm.hideQuoteLimit"
            @input="hideQuoteLimitChange">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="editPriceShow = false">取消</el-button>
        <el-button type="primary" @click.native="submitEditPrice()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 压价设置最终确定提示框 -->
    <el-dialog class="acc_dialog" title="提示" :visible.sync="yajiaShow" :close-on-click-modal="false" width="500px"
      @closed="yajiaShow = false">
      <div style="margin-bottom: 20px; font-weight: 500 ;text-align: center;font-size: 18px;">
        是否确认修改压价设置？
      </div>
      <div class="command">
        <div>动态口令：</div>
        <el-input v-model="yaCommand" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="yajiaShow = false">取消</el-button>
        <el-button type="primary" @click.native="yaPricesure">确定</el-button>
      </span>
    </el-dialog>
    <!--添加编辑弹框-->
    <el-dialog class="add-store" :title="`${storeDiaTitle}` + '门店'" :visible.sync="dialogStoreVisible"
      :close-on-click-modal="false" width="500px" @closed="closeDialogStore">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="门店编码" prop="storeCode">
          <el-input v-model="ruleForm.storeCode" maxlength="30" placeholder="请输入门店编码，如门店erp编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="门店名称" prop="storeName">
          <el-input v-model="ruleForm.storeName" placeholder="请输入繁星回收门店名称，最多可输入20字" maxlength="20" clearable></el-input>
        </el-form-item>
        <el-form-item label="门店地址" prop="storeAddress">
          <el-input v-model="ruleForm.storeAddress" placeholder="请输入详细地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="合作回收商" prop="merchantIds">
          <el-select multiple collapse-tags v-model="ruleForm.merchantIds" @change="changeSelect" @remove-tag="removeTag"
            placeholder="请选择合作回收商" filterable clearable>
            <el-option v-if="merchantList.length" label="全部选择" value="全部选择" @click.native="selectAll"></el-option>
            <el-option v-for="(item, index) in merchantList" :key="index"
              :label="item.quoteMachineType == '01' ? item.merchantName + '（全品类)' : item.merchantName + '（指定品类)'"
              :value="item.merchantId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float:right">
          <el-button @click="closeDialogStore">取消</el-button>
          <el-button type="primary" :loading="btnLoading" @click="handleSuccess('ruleForm')">{{
            this.storeDiaTitle ? this.storeDiaTitle : "确定"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <DialogTbale @onClose="onClose" :show="staffVisible" title="店员列表" :columns="DialogTableColumns" :data="DialogDataList"
      :currentPage="pageNum" :total="total" :pageSize="pageSize" :width="1210"
      @handleCurrentChange="handleCurrentChangeDialog">
      <div style="margin-bottom:20px;display:flex">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input v-model="formInline.staffName" placeholder="请输入店员姓名" class="form_input"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="formInline.staffMobile" placeholder="请输入店员电话" class="form_input"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getStaffList(1)" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table-column label="职位" slot="staffType" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.staffType == '02'">总监</span>
          <span v-else-if="row.staffType == '03'">门店店长</span>
          <span v-else-if="row.staffType == '04'">普通职员</span>
        </template>
      </el-table-column>
    </DialogTbale>
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import _api from "@/utils/request";
let checkNum = (rule, value, callback) => {
  if (value == 0 || value > 100) {
    callback(new Error("加价比例必须大于0小于等于100"));
  } else {
    callback();
  }
};
export default {
  name: "Table",
  mixins: [MinXinRequest],
  props:{
    isOpenBuyNiceMachine:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      configAlldata: {},
      //压价
      ifedmit: true,//true-编辑;false添加
      yajiaShow: false,
      yaCommand: "",
      proportion: 1,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      editPricerules: {
        hideQuoteRatio: [
          { required: true, message: "请输入压价隐藏比例", trigger: "blur" },
          { type: "number", validator: checkNum, trigger: "blur" },
        ],
        hideQuoteLimit: [
          {
            required: true,
            message: "请输入压价上限",
            trigger: "blur",
          },
        ],
      },
      editPriceForm: {
        startQuote: "",
        endQuote: "",
        hideQuoteRatio: "",
        hideQuoteLimit: "",
      },
      addPriceShow: false,
      quoteList: [],
      // 报价设置修改
      pattern: '00',//门店店长设置('00')--有添加/编辑/删除
      editPriceShow: false,
      // *************
      // 店员弹窗
      formInline: {
        staffName: "",
        staffMobile: "",
      },
      storeId: "",
      staffVisible: false,
      btnLoading: false,
      total: 0,
      regionColumns: [
        { slotName: "rank" },
        { slotName: "markUpLimit" },
        { slotName: "hideQuoteRatio" },
        { slotName: "hideQuoteLimit" },
        { slotName: "operation" },
      ],
      pageNum: 1,
      pageSize: 10,
      DialogDataList: [],
      DialogTableColumns: [
        { label: "店员姓名", prop: "staffName" },
        { slotName: "staffType" },
        { label: "联系电话", prop: "staffMobile" },
      ],
      //////////列表
      seachDataList: [],
      //弹窗
      dialogVisible: false, // 弹框的出现与否
      ////////
      tableColumns: [
        { slotName: "areaName" },
        { slotName: "tagList" },
        { label: "门店名称", prop: "storeName" },
        // { label: "店长", prop: "storeManager" },
        { slotName: "storeCode" },
        { slotName: "storeMana" },
        // { label: "联系电话", prop: "storeManagerPhone" },
        { slotName: "operationImg" },
        { slotName: "storeAddress" },
        // { label: "门店地址", prop: "storeAddress" },
        { label: "添加时间", prop: "createTime" },
        { slotName: "operationSex" },
        { slotName: "operation" },
      ],
      // 添加编辑门店弹窗
      editId: "",
      storeDiaTitle: "",
      ruleForm: {
        storeName: "",
        storeCode: "",
        storeAddress: "",
        merchantIds: [],
      },
      rules: {
        storeName: [
          { required: true, message: "请输入门店名称", trigger: "change" },
        ],
        storeAddress: [
          { required: true, message: "请输入门店地址", trigger: "change" },
        ]
      },
      dialogTitle: "",
      dialogStoreVisible: false,
      //////////////报价设置弹窗
      dialogQuotatVisible: false,
      DialogCode: false,
      merchantList: [],
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
    storeAddEdit() {
      return this.$store.state.tagsView.storeAddEdit;
    },
    storeExcel() {
      return this.$store.state.tagsView.storeExcel;
    },
  },
  created() {
    this.findInquiryMerchantEnable();
    this.handleCurrentChange(1);
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange();
    },
    storeAddEdit(newVal) {
      if (newVal === "add") {
        this.selectAll()
        this.storeDiaTitle = "添加";
        this.dialogStoreVisible = true;
        this.ruleForm.storeAddress = "";
        this.ruleForm.storeCode = "";
        this.ruleForm.storeName = "";
      } else {
        this.storeDiaTitle = "编辑";
      }
    },
    storeExcel(newVal) {
      console.log(newVal, "storeExcel");
      if (newVal == "storeExcel") {
        this.handleCurrentChange(1);
      }
    },
    dialogStoreVisible(newVal) {
      if (newVal === false) {
        this.$store.commit("tagsView/STORE_ADDEDIT", "edit");
      }
    },
  },
  methods: {
    //压价
    limitInput(value, name) {
      let str = (value && value.split("")) || [];
      let reg1 = /\d/;
      let reg2 = /\./;
      // 第一个字符不能为小数点
      if (str[0] == ".") {
        this.editPriceForm[name] = "";
        return;
      }
      // 过滤掉除数字和小数点外的字符
      value = str.filter((e) => reg1.test(e) || reg2.test(e));
      // 匹配小数点后只能有两位小数
      let valJoin = value.join("");
      // this.editPriceForm[name] =value.replace(/[^0-9]/g,'')
      this.editPriceForm[name] = valJoin.match(/^\d*(\.?\d{0,2})/g)[0] || "";
      if (this.editPriceForm[name] >= 100) {
        this.editPriceForm[name] = "99";
      }
    },
    // 最低值规则设置
    hideQuoteStartQuoteChange(v){
      if (isNaN(Number(v))) {
        return (this.editPriceForm.startQuote = null);
      }
      if (parseInt(v) < 0) {
        return (this.editPriceForm.startQuote = null);
      }
    },
    // 最高值规则设置
    hideQuoteEndQuoteChange(v){
      if (isNaN(Number(v))) {
        return (this.editPriceForm.endQuote = null);
      }
      if (parseInt(v) < 0) {
        return (this.editPriceForm.endQuote = null);
      }
    },
    hideQuoteLimitChange(v) {
      if (isNaN(Number(v))) {
        return (this.editPriceForm.hideQuoteLimit = null);
      }
      if (parseInt(v) < 0) {
        return (this.editPriceForm.hideQuoteLimit = null);
      }
      if (
        (this.maxHideQuoteLimit || parseInt(this.maxHideQuoteLimit) === 0) &&
        Number(v) > this.maxHideQuoteLimit
      ) {
        return (this.editPriceForm.hideQuoteLimit = this.maxHideQuoteLimit);
      }
      if (!this.maxHideQuoteLimit) {
        this.editPriceForm.hideQuoteLimit = v;
      }
    },
    // 失焦
    inputBlur(name) {
      console.log(this.editPriceForm[name]);
      if (
        this.editPriceForm[name].toString().indexOf(".") ==
        this.editPriceForm[name].length - 1
      ) {
        this.editPriceForm[name] = this.editPriceForm[name].replace(".", "");
      }
    },
    //确认压价动态口令
    // yaPricesure() {
    //   if (!this.yaCommand) {
    //     this.$message.error("请输入动态口令！");
    //     return;
    //   }
    //   const params = {
    //     command: this.yaCommand,
    //     companyId: this.storeId,
    //     isStoreShowQuoteConfig: "",
    //     isUnify: "",
    //     quoteConfigDtos: [],
    //   };
    //   // params.isStoreShowQuoteConfig = this.proportion == 1 ? "01" : "00";
    //   params.isUnify = this.pattern == '01' ? "01" : "00";
    //   if (this.pattern == '01') {
    //     params.quoteConfigDtos = this.quoteList;
    //   }
    //   console.log(params,'paramsparams');
    //   _api.saveyajiaConfig(params).then((res) => {
    //     if (res.code == 1) {
    //       this.addPriceShow = false;
    //       this.yajiaShow = false;
    //       this.$message({
    //         message: "保存成功！",
    //         type: "success",
    //       });
    //     }
    //   });
    // },
    //确认压价
    submitAddPrice() {
      // 不需要动态口令
      // this.yajiaShow = true;
      // this.yaCommand = "";
      // ********
      const params = {
        storeId: this.storeId,
        quoteConfigDtos: this.quoteList,
      };
      _api.saveQuoteConfig(params).then((res) => {
        if (res.code == 1) {
          this.addPriceShow = false;
          // this.yajiaShow = false;
          this.$message({
            message: "保存成功！",
            type: "success",
          });
          setTimeout(() => {
            this.dialogQuotatVisible = false;
          }, 500)
        }
      });
    },
    // 编辑弹框确认
    submitEditPrice() {
      this.$refs["editPriceRulesForm"].validate((valid) => {
        if (valid) {
          if (this.ifedmit) {//编辑
            this.quoteList.forEach((item) => {
              if (item.id == this.rowId) {
                item.hideQuoteRatio = this.editPriceForm.hideQuoteRatio;
                item.quoteRatio =
                  100 - Number(this.editPriceForm.hideQuoteRatio);
                item.startQuote = this.editPriceForm.startQuote;
                item.endQuote = this.editPriceForm.endQuote;
                item.hideQuoteLimit = this.editPriceForm.hideQuoteLimit;
              }
            });
          } else {//添加
            if (
              !this.editPriceForm.startQuote ||
              !this.editPriceForm.endQuote
            ) {
              this.$message.error("请填写最高门店显示价区间！");
              return;
            }
            if (
              this.editPriceForm.startQuote &&
              this.editPriceForm.endQuote &&
              Number(this.editPriceForm.endQuote) <=
              Number(this.editPriceForm.startQuote)
            ) {
              this.$message.error("最高门店显示价必须大于最低门店显示价！");
              return;
            }
            this.quoteList.push({
              hideQuoteRatio: this.editPriceForm.hideQuoteRatio,
              quoteRatio: 100 - Number(this.editPriceForm.hideQuoteRatio),
              startQuote: this.editPriceForm.startQuote,
              endQuote: this.editPriceForm.endQuote,
              id: this.quoteList.length + "yj",
              hideQuoteLimit: this.editPriceForm.hideQuoteLimit,
            });
          }
          this.editPriceShow = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //关闭编辑
    editPriceClosed() {
      this.$refs["editPriceRulesForm"].resetFields();
      this.rowId = "";
      this.editPriceForm = {
        startQuote: "",
        endQuote: "",
        hideQuoteRatio: "",
      };
    },
    //删除压价
    deletConfig(row) {
      this.quoteList.forEach((res, index) => {
        if (res.id == row.id) {
          this.quoteList.splice(index, 1);
        }
      });
    },
    // 压价配置编辑
    editConfig(row) {
      this.editPriceShow = true;
      if (row) {
        this.ifedmit = true; //编辑
        this.rowId = row.id;
        this.editPriceForm = {
          startQuote: row.startQuote,
          endQuote: row.endQuote,
          hideQuoteRatio: row.hideQuoteRatio,
          hideQuoteLimit: row.hideQuoteLimit,
        };
      } else {
        this.ifedmit = false;//添加
      }
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(val);
      const baseRequest = {
        storeManager: this.SeachParams.storeManager,
        storeManagerPhone: this.SeachParams.staffMobile,
        storeName: this.SeachParams.storeName,
        isOpenSelfBuyNiceMachine:this.SeachParams.isOpenSelfBuyNiceMachine,
        pageNum: val ? val : this.SeachParams.pageNum,
        areaId: this.SeachParams.areaId,
        tagId: this.SeachParams.tagId,
        pageSize: 10,
      };
      this.$emit("handleCurrentChange", val);
      _api.StaffManageList(baseRequest).then((res) => {
        if (res.code === 1) {
          console.log(res);
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.$store.commit("tagsView/POST_STAFF", this.seachDataList);
          this.$store.commit("tagsView/STORE_EXCEL", "false");
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 表格按钮操作
    handleBtn(row, type) {
      console.log("表格操作", type, row);
      if (type == "edit") {
        this.ruleForm.storeAddress = row.storeAddress;
        this.ruleForm.storeCode = row.storeCode;
        this.ruleForm.storeName = row.storeName;
        this.ruleForm.merchantIds = row.merchantIds;
        this.editId = row.id;
        this.addEdit = type;
        this.storeDiaTitle = "编辑";
        this.dialogStoreVisible = true;
        this.changeSelect(row.merchantIds)
      } else if (type == "price") {//报价设置
        this.storeId = row.id;
        this.dialogQuotatVisible = true;
        this.PostQuoteConfig();
      }
    },
    //启用/禁用账号
    handleSwitch(row) {
      const params = {
        id: row.id,
        isEnable: row.isEnable,
        type: row.type,
      };
      _api.updateIsEnable(params).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
        this.handleCurrentChange();
      });
    },
    //靓机自收
    SwitchRenew(row) {
      const params = {
        id: row.id,
        isOpenSelfBuyNiceMachine: row.isOpenSelfBuyNiceMachine,
      };
      _api.updateIsOpenSelfBuyNiceMachine(params).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
        this.handleCurrentChange();
      }).catch(err=>{
        this.handleCurrentChange();
      });
    },
    //弹窗取消
    handleDialogClosed() {
      // this.dialogVisible = false;
    },
    handleCurrentChangeDialog(val) {
      console.log(val);
      this.pageNum = val;
      this.getStaffList(val);
    },
    //查看店员
    staffDia(row) {
      this.staffVisible = true;
      this.storeId = row.id;
      console.log(row);
      this.pageNum = 1;
      this.getStaffList(1);
    },
    getStaffList(val) {
      console.log(val);
      const params = {
        pageSize: this.pageSize,
        pageNum: val ? val : this.pageNum,
        storeId: this.storeId,
        staffName: this.formInline.staffName,
        staffMobile: this.formInline.staffMobile,
      };
      _api.getStaffList(params).then((res) => {
        console.log(res);
        this.DialogDataList = res.data.records;
        this.total = res.data.total;
      });
    },
    onClose() {
      this.staffVisible = false;
    },
    closeDialogStore() {
      this.dialogStoreVisible = false;
      this.$refs["ruleForm"].resetFields();
      this.ruleForm.merchantIds = []
    },
    ///////////////////添加编辑门店弹窗
    handleStoreClosed() {
      this.dialogStoreVisible = false;
    },
    handleSuccess(formName) {
      console.log(this.storeDiaTitle);
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let merchantIds = []
          this.ruleForm.merchantIds.forEach(item => {
            if (item != '全部选择') {
              merchantIds.push(item)
            }
          });
          let params = {
            id: this.storeDiaTitle === "编辑" ? this.editId : null,
            storeCode: this.ruleForm.storeCode,
            storeAddress: this.ruleForm.storeAddress,
            storeName: this.ruleForm.storeName,
            merchantIds,
          }
          this.btnLoading = true
          _api.saveStore(params).then((res) => {
            console.log(res);
            if (res.code === 1) {
              this.$message.success(res.msg);
              this.dialogStoreVisible = false;
              this.handleCurrentChange(1);
              this.$refs[formName].resetFields();
            } else {
              this.$message.success(res.msg);
            }
            this.btnLoading = false
          }).catch(() => {
            this.btnLoading = false
          });
        } else {
          return false;
        }
      });
    },
    //////标价设置弹窗
    PostQuoteConfig() {
      const params = {
        pageNum: 1,
        pageSize: 10,
        storeId: this.storeId,
      };
      _api.quoteConfigList(params).then((res) => {
        console.log(res);
        this.configAlldata = res.data
        this.quoteList = res.data.ipage.records;
        this.pattern = res.data.isUnify
        console.log(this.quoteList, "this.quoteList");
      });
    },
    ///查看二维码
    AddQustion() {
      this.DialogCode = true;
    },
    findInquiryMerchantEnable() {
      _api.findInquiryMerchantEnable().then((res) => {
        console.log(res);
        this.merchantList = res.data;
      });
    },
    selectAll() {
      if (this.ruleForm.merchantIds.length < this.merchantList.length) {
        this.ruleForm.merchantIds = [];
        this.merchantList.map((item) => {
          this.ruleForm.merchantIds.push(item.merchantId);
        });
        this.ruleForm.merchantIds.unshift("全部选择");
      } else {
        this.ruleForm.merchantIds = [];
      }
    },

    changeSelect(val) {
      console.log(val);
      if (!val || !val.length) {
        this.ruleForm.merchantIds = []
        return
      }
      if (!val.includes("全部选择") && val.length === this.merchantList.length) {
        this.ruleForm.merchantIds.unshift("全部选择");
      } else if (val.includes("全部选择") && val.length - 1 < this.merchantList.length) {
        this.ruleForm.merchantIds = this.ruleForm.merchantIds.filter((item) => {
          return item !== "全部选择";
        });
      }
      console.log(this.ruleForm.merchantIds);
    },
    removeTag(val) {
      if (val === "全部选择") {
        this.ruleForm.merchantIds = [];
      }
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
/deep/.el-input-group__append {
  background-color: #0981ff !important;
}

.command {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /deep/ .el-input {
    width: 80% !important;
  }
}

.acc_dialog {
  /deep/ .el-input {
    width: 240px;
  }
}

.GlobalTable {
  /deep/ .form_input .el-input__inner {
    height: 30px !important;
  }

  .widQus {
    width: 96%;
    margin: 15px auto;
  }

  .qustion-top {
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 15px;

    img {
      width: 18px;
      object-fit: contain;
      margin-right: 5px;
    }

    div {
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      color: #ff687b;
      line-height: 0px;
    }
  }

  .box-qustion {
    // min-height: 276px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
    background: #f5f5f5;
    border-radius: 4px;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qustion-item {
    padding-bottom: 10px;

    .el_input_item {
      width: 100px !important;
    }

    /deep/ .el-input__inner {
      height: 35px !important;
    }

    .left {
      margin: 20px 50px 0 10px;
    }

    .right {
      margin: 20px 10px 0 0;
    }

    .text {
      margin-right: 5px;
    }
  }

  .img_code {
    width: 200px;
    height: 200px;
    margin: 20px auto;

    img {
      width: 100%;
      object-fit: contain;
    }
  }

  /*修改滚动条样式*/
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 6px;
    width: 8px;
    background: white;
  }

  ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    width: 5px;
    background-color: #0981ff;
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: #0981ff;
    -webkit-border-radius: 6px;
    -webkit-border-radius: 6px;
  }

  .none-Data {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 22px;
    color: #666;
  }

  /deep/.add-store .el-select {
    width: 100%;
  }

  /deep/.add-store .el-tag.el-tag--info {
    background-color: #fbfbfb;
    border-color: #cecdcd;
    color: #666666;
  }
}
::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}
/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 20px;
}
/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 20px;
}
/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}
::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 55px;
}
</style>
